/* istanbul ignore file */

const LanguageToggleComponent = () => {
  return null
}

export default LanguageToggleComponent
